import { MeasureIntervalState } from '../../types/sharedTypeImpl.ts';


export function measureIntervalSort(rows: MeasureIntervalState[]) {
    return rows.sort(measureIntervalCompare);
}

function measureIntervalCompare(a: MeasureIntervalState, b: MeasureIntervalState) {
    return withoutProductToBottom(a, b)
        || inSetupToBottom(a, b)
        || fixInProgressToBottom(a, b)
        || earlyQuickFixesToTop(a, b)
        || earlyHelpMeToTop(a, b)
        || earlyToolChangesToTop(a, b)
        || compareIntervalPrediction(a, b)
        || compareEquipmentDisplayName(a, b);
}

function withoutProductToBottom(a: MeasureIntervalState, b: MeasureIntervalState) {
    const aDefined = a.product != undefined && a.product != null;
    const bDefined = b.product != undefined && b.product != null;
    return +bDefined - +aDefined;
}

function inSetupToBottom(a: MeasureIntervalState, b: MeasureIntervalState) {
    return +(b.isSetupComplete ?? false) - +(a.isSetupComplete ?? false);
}

function earlyQuickFixesToTop(a: MeasureIntervalState, b: MeasureIntervalState) {
    const aStopped = a.stopStatus ==='workCounter';
    const bStopped = b.stopStatus === 'workCounter';
    if (aStopped && bStopped) {
        return +(a.stopStatusStart ?? 0) - +(b.stopStatusStart ?? 0);
    } else {
        return +bStopped - +aStopped;
    }
}

function earlyHelpMeToTop(a: MeasureIntervalState, b: MeasureIntervalState) {
    const aStopped = a.stopStatus ==='helpMe';
    const bStopped = b.stopStatus === 'helpMe';
    if (aStopped && bStopped) {
        return +(a.stopStatusStart ?? 0) - +(b.stopStatusStart ?? 0);
    } else {
        return +bStopped - +aStopped;
    }
}

function earlyToolChangesToTop(a: MeasureIntervalState, b: MeasureIntervalState) {
    const aStopped = a.stopStatus ==='toolChange';
    const bStopped = b.stopStatus === 'toolChange';
    if (aStopped && bStopped) {
        return +(a.stopStatusStart ?? 0) - +(b.stopStatusStart ?? 0);
    } else {
        return +bStopped - +aStopped;
    }
}

function fixInProgressToBottom(a: MeasureIntervalState, b: MeasureIntervalState) {
    const aFixInProgress = a.stopStatus === 'fixInProgress';
    const bFixInProgress = b.stopStatus === 'fixInProgress';
    if (aFixInProgress && bFixInProgress) {
        return +(a.stopStatusStart ?? 0) - +(b.stopStatusStart ?? 0);
    } else {
        return +aFixInProgress - +bFixInProgress;
    }
}

function compareIntervalPrediction(a: MeasureIntervalState, b: MeasureIntervalState) {
    const aDefined = a.intervalDueAt != null;
    const bDefined = b.intervalDueAt != null;
    if (aDefined && bDefined) {
        return +a.intervalDueAt! - +b.intervalDueAt!;
    } else {
        return +bDefined - +aDefined;
    }
}

function compareEquipmentDisplayName(a: MeasureIntervalState, b: MeasureIntervalState) {
    return a.displayName.localeCompare(b.displayName);
}
